
$(function () {
    $("body").on("click", "ul.widget-simple-list span.glyphicon-remove", function () {
        var data = null;

        if ($(this).parents(".list-group-item").data("object"))
            data = $(this).parents(".list-group-item").data("object");
        else if ($(this).parents(".list-group-item").data("value"))
            data = $(this).parents(".list-group-item").data("value");

        if (!data) return;

        $(this).parents("ul.widget-simple-list").parents(".widget").trigger(WidgetEvents.SIMPLE_LIST_REMOVE, data);
        $(this).parents("ul.widget-simple-list").trigger(WidgetEvents.SIMPLE_LIST_REMOVE, data);       
        $(this).parents("li.list-group-item").remove();
    });

    $(".widget-simple-list").each(function (idx, element) {
        var source = $(this).data("event-source-selector");
        var type = $(this).data("event-source-type");
        var _self = this;
        
        if (source && type) {
            $(source).on(type, function (e, data) {
                if (data && data.value) {
                    var existing = $(_self).find(".list-group-item").filter(function () {
                        return $(this).data("value") === data.value;
                    });

                    if (existing.length > 0) return;

                    var texts = $(_self).data("text");
                    var values = $(_self).data("value");

                    var $cmd = $("<span class='glyphicon glyphicon-remove' title='Remove'></span>");
                    var $text = $("<span class='item-text'></span>").attr("title", data.text).html(data.text);
                    var $inner = $("<span class='item'></span>").append($cmd).append($text);

                    var $li = $("<li class='list-group-item'></li>").append($inner).data("value", data.value)
                        .data("object", data);

                    if (texts) {
                        var $textsInput = $("<input type='hidden' name='" + texts + "' value='" + data.text + "' />");
                        $li.append($textsInput);
                    }

                    if (values) {
                        var $valuesInput = $("<input type='hidden' name='" + values + "' value='" + data.value + "' />");
                        $li.append($valuesInput);
                    }

                    $(_self).append($li);
                    $(_self).children().sort(function (a, b) {
                        return ($(b).find(".item-text").text()) < ($(a).find(".item-text").text()) ? 1 : -1;
                    }).appendTo(_self);
                }
            });
        }
    });
});